import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Text, Badge } from "@mantine/core";
import { IconHeart, IconMail } from "@tabler/icons-react";
import { UserType } from "../utils/types";
import UserAvatar from "./UserAvatar";
import { auth } from "../firebase";
import { countries } from "../utils/countries";
import { toast } from "react-toastify";

interface UserSmallTileProps {
  user: UserType;
  loggedinUserConnections: string[];
}

const UserSmallTile = (props: UserSmallTileProps) => {
  const navigate = useNavigate();
  const [isConnected, setIsConnected] = useState(false);
  const { user, loggedinUserConnections } = props;

  useEffect(() => {
    if (loggedinUserConnections.length > 0) {
      const connected = loggedinUserConnections.filter((x) => x === user.id);
      if (connected.length > 0) setIsConnected(true);
      else setIsConnected(false);
    }
  }, [loggedinUserConnections]);

  useEffect(() => {
    if (!auth.currentUser?.uid || !user) return;
  }, [auth.currentUser?.uid, user]);

  const handleCardClick = () => {
    if (auth.currentUser) navigate(`/userprofile/${user.id}`);
    else toast.info("Please login to view user profile");
  };

  return (
    <Card
      style={{
        width: 350,
        height: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "#a5faf7",
        cursor: "pointer",
        position: "relative",
        overflow: "visible",
        padding: "16px",
        borderRadius: "16px",
        margin: "20px",
      }}
      onClick={handleCardClick}
    >
      <div style={{ display: "flex", width: "100%" }}>
        <UserAvatar photoURL={user.photoURL} name={user.name} size={100} />
        <div
          style={{
            overflow: "hidden",
            flexGrow: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexGrow: 1,
              justifyContent: "space-between",
              paddingLeft: "6px",
            }}
          >
            <h3>{user.name}</h3>
            <div style={{ marginLeft: "auto" }}>
              {isConnected && (
                <IconHeart
                  size={25}
                  stroke={0}
                  fill={"red"}
                  style={{ cursor: "pointer" }}
                />
              )}
            </div>
          </div>
          <Text
            size="sm"
            style={{
              textAlign: "center",
              backgroundColor: "dimmed",
              maxWidth: "200",
              paddingLeft: "6px",
              overflowWrap: "break-word",
            }}
          >
            {user.description.length > 100
              ? `${user.description.substring(0, 100)} ...`
              : user.description}
          </Text>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: "auto" }}>
        <p style={{ fontSize: "12px" }}>
          {countries.find((c) => c.code === user.country)?.name || ""}
          {user.country && user.city ? ",\u00A0" : ""}
          {user.city}
        </p>
      </div>

      {user.unreadMessages && (
        <Badge
          color="red"
          radius="xl"
          size="lg"
          style={{
            position: "absolute",
            top: -10,
            right: -10,
            width: 25,
            height: 25,
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
          }}
        >
          <IconMail
            size={20}
            style={{
              lineHeight: 1, // Adjust the line height to prevent extra spacing
              transform: "translateY(3px)", // Fine-tune vertical alignment by shifting the icon slightly
            }}
          />
        </Badge>
      )}
    </Card>
  );
};

export default UserSmallTile;
